const initProductDescriptionToggle = (selector = ".about-luxury__text p", limit = 356) => {
  const boxes = document.querySelectorAll(selector);

  boxes.forEach((descBox) => {
    // Prevent duplicate initialization
    if (descBox.dataset.initialized === "true") return;

    const fullText = descBox.textContent.trim();

    if (fullText.length <= limit) return;
    descBox.classList.add("is-collapsed");
    const shortText = fullText.substring(0, limit);
    console.log(shortText,'shortText');
    let isExpanded = false;

    // Store original text
    descBox.dataset.fullText = fullText;
    descBox.dataset.shortText = shortText;
    descBox.dataset.initialized = "true";

    descBox.textContent = shortText;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "toggle-btn";
    btn.textContent = "Read more...";

    Object.assign(btn.style, {
      border: "none",
      background: "transparent",
      color: "#000",
      cursor: "pointer",
      fontSize: "14px",
      padding: "4px 0",
      display: "block"
    });

    btn.addEventListener("click", (e) => {
      e.preventDefault();

      isExpanded = !isExpanded;

      descBox.firstChild.textContent = isExpanded
        ? descBox.dataset.fullText
        : descBox.dataset.shortText;

      btn.textContent = isExpanded ? "Read less" : "Read more";
    });

    descBox.appendChild(btn);
  });
};

const handleProductToggle = () => {
  const selector = ".about-luxury__text p";

  if (window.innerWidth < 989) {
    initProductDescriptionToggle(selector);
  } else {
    // Reset to full text on desktop
    document.querySelectorAll(selector).forEach((descBox) => {
      if (descBox.dataset.fullText) {
        descBox.textContent = descBox.dataset.fullText;
        delete descBox.dataset.initialized;
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", handleProductToggle);
window.addEventListener("resize", handleProductToggle);